/*****
 * ====================================================================================
 * Project: noloResponsiveHelper jQuery Plugin
 * Description: provides a js utility to detect the current window width for media query states
 * Author: Ian Cruz @ Nolo
 * Version: 1.1.0
 * jQuery Version: 2.1.4
 * ====================================================================================
 *
 * @version_history
 * 1.0.0
 * + initial plugin creation
 *
 * 1.1.0
 * + add 'enter' and 'leave' events
 *
 * 1.1.1
 * + update jQuery version
 */




// noloResponsiveHelper JQUERY PLUGIN
// ====================================================================================
+function ($, window, document, undefined) {
    'use strict';

    // noloResponsiveHelper PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    // ================================================================================
    var responsiveHelper = function (element, options) {
        this.$element   = $(element);
        this.options    = $.extend(true, {}, responsiveHelper.DEFAULTS, this.getDataAttributeOptions(), options);
        this.$window    = $(window);
        this.ranges     = this.getRanges();
        this.nativeMatchMedia = this.detectMatchMedia();

        // Initialize the plugin
        this.init();
    }




    // noloResponsiveHelper PLUGIN NAMESPACE
    // ================================================================================
    responsiveHelper.NAMESPACE  = 'nolo';
    responsiveHelper.NAME       = 'noloResponsiveHelper';
    responsiveHelper.DATAID     =  responsiveHelper.NAMESPACE + '.' + responsiveHelper.NAME;




    // noloResponsiveHelper VERSION
    // ================================================================================
    responsiveHelper.VERSION  = '1.1.1';




    // noloResponsiveHelper DEFAULT OPTIONS
    // ================================================================================
    responsiveHelper.DEFAULTS = {
        'classPrefix':  'media-range',
        'defaultRange': 'undefined',
        'rangeMobile':  [null, 767],
        'rangeTablet':  [768, 979],
        'rangeDesktop': [980, 1385],
        'rangeWide':    [1386, null],
        'customRanges': {},
    }




    // noloResponsiveHelper PUBLIC METHODS
    // ================================================================================
    /**
     * Initializes the plugin
     * @params N/A
     * @return undefined
     */
    responsiveHelper.prototype.init = function(){
        var rh   = this;
        var $win = this.$window;

        // bind the resize handler to sizing events
        $win.bind('load resize orientationchange', function(event){
            rh.resizeHandler();
        });
        return;
    }

    responsiveHelper.prototype.getDataAttributeOptions = function(){
        var options = this.$element.data();
        return options;
    }

    responsiveHelper.prototype.getRanges = function(){
        var options = this.options;
        var ranges = {
            'mobile':  options.rangeMobile,
            'tablet':  options.rangeTablet,
            'desktop': options.rangeDesktop,
            'wide':    options.rangeWide,
        }

        return $.extend(true, {}, ranges, options.customRanges);
    }

    responsiveHelper.prototype.detectMatchMedia = function(){
        // detect match media support
        if(window.matchMedia) {
            if(window.Window && window.matchMedia === Window.prototype.matchMedia) {
                return true;
            } else if(window.matchMedia.toString().indexOf('native') > -1) {
                return true;
            }
        }

        return false;
    }

    responsiveHelper.prototype.resizeHandler = function(){
        var $win     = this.$window;
        var winWidth = $win.width();
        var options  = this.options;
        var ranges   = this.ranges;
        var currentRange = this.currentRange || options.defaultRange;
        var match, test;

        //do something only when the window widths changed
        if(winWidth != this.prevWidth){

            // update the prevWidth property
            this.prevWidth = winWidth;

            // test if the current range has not changed
            if(typeof currentRange != 'undefined' && currentRange !== options.defaultRange) {
                match = this.testRangeByName(currentRange);
            }

            // perform the matching only if the current range changed
            if(!match){
                // store the previous range for class toggling
                this.previousRange = currentRange;

                // reset current range value
                this.currentRange = options.defaultRange;

                // find the matching media query range
                for (var r in ranges){
                    test = this.testRangeByName(r);

                    if(test){
                        // update current range value
                        this.currentRange = r;

                        // set element class
                        this.setMatchClass();
                        return;
                    }
                }

                // set element class
                this.setMatchClass();
            }

            return;
        }
    }

    responsiveHelper.prototype.testRangeByName = function(name){
        var ranges = this.ranges;

        if(typeof ranges[name] !== 'undefined'){
            return this.testRange(ranges[name][0], ranges[name][1]);
        }

        return false;
    }

    responsiveHelper.prototype.testRange = function(r1, r2){
        // use of window.matchMedia, or any vendor implementation of it, requires a very specific string syntax for matching
        // build the query string by testing the arguments of this method
        var query = '';

        // set min-width string
        if(r1 > 0 && r1 !== null) {
            query += '(min-width: ' + r1 + 'px)';
        }

        // set max-width string
        if(r2 < Infinity && r2 !== null) {
            query += (query ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
        }

        // perform the actual check
        return this.testQuery(query, r1, r2);
    }

    responsiveHelper.prototype.testQuery = function(query, r1, r2){
        var nativeMatchMedia = this.nativeMatchMedia;
        var prevWidth = this.prevWidth;

        if(window.matchMedia && nativeMatchMedia) {
            // match range against the matchMedia method, if supported natively
            return matchMedia(query).matches;
        } else if(window.styleMedia) {
            // match range against ie9's styleMedia method
            return styleMedia.matchMedium(query);
        } else {
            // match range against detected window width
            return prevWidth >= r1 && prevWidth <= r2;
        }
    }

    responsiveHelper.prototype.setMatchClass = function(){
        var $elm    = this.$element;
        var options = this.options;
        var prevClass    = options.classPrefix + '-' + this.previousRange;
        var currentClass = options.classPrefix + '-' + this.currentRange;

        if(prevClass !== currentClass){
            // remove the 'previous' range class
            if($elm.hasClass(prevClass)){
                $elm.removeClass(prevClass);

                // trigger 'leave' event
                $elm.trigger('leave.nRH.'+this.previousRange);
            }

            // add the 'current' range class
            $elm.addClass(currentClass);

            // trigger 'enter' event
            $elm.trigger('enter.nRH.'+this.currentRange)
        }
    }

    responsiveHelper.prototype.isMobile = function(){
        return this.testRangeByName('mobile');
    }

    responsiveHelper.prototype.isTablet = function(){
        return this.testRangeByName('tablet');
    }

    responsiveHelper.prototype.isDesktop = function(){
        return this.testRangeByName('desktop');
    }

    responsiveHelper.prototype.isWide = function(){
        return this.testRangeByName('wide');
    }

    // noloResponsiveHelper PLUGIN DEFINITION
    // ================================================================================
    function Plugin(option) {
        // store arguments into a local variable so we can reference it for the public methods
        var args = arguments;

        return this.each(function(idx) {
            var $this   = $(this);
            var data    = $this.data(responsiveHelper.DATAID);
            var options = typeof option == 'object' && option;

            // initialize the plugin for this element for the first time
            if (!data){
                // store the index of this particular instance so we can auto generate ids
                if(typeof options == 'object'){
                    // a configuration object was passed into the plugin
                    // add the 'idx' property into 'options'
                    options.idx = idx;
                } else {
                    // a configuration object was NOT passed into the plugin
                    // declare the 'options' variable as an object with at least the 'idx' property assigned to it
                    options = {
                        'idx': idx,
                    };
                }

                // store the instance of this plugin for this element into memory, if none exists
                // this will initialize the plugin using the 'options' configuration
                $this.data(responsiveHelper.DATAID, (data = new responsiveHelper(this, options)));
            }

            // call a public method against the initialized plugin
            if (typeof option == 'string'){
                data[option].apply(this, Array.prototype.slice.call(args, 1));
            }
        })
    }

    // assign a previous plugin definition into another variable for 'noConflict'
    var old = $.fn[responsiveHelper.NAME];

    // assign the responsiveHelper PLUGIN DEFINITION
    $.fn[responsiveHelper.NAME]                = Plugin;

    // assign the responsiveHelper PUBLIC CLASS DEFINITION (CONSTRUCTOR)
    $.fn[responsiveHelper.NAME]['constructor'] = responsiveHelper;




    // noloResponsiveHelper NO CONFLICT
    // ================================================================================
    $.fn[responsiveHelper.NAME]['noConflict'] = function () {
        $.fn[responsiveHelper.NAME] = old;
        return this;
    }




    // noloResponsiveHelper DATA-API
    // ================================================================================
    $(document).ready(function(){
        var $elm = $('[data-toggle="noloResponsiveHelper"]'),
        option = {};

        // initialize the plugin upon document ready
        Plugin.call($elm, option);
    });
}(jQuery, window, document);
